@if (item) {
  <div class="message-panel-item">
    <div class="text-wrapper">
      <i class="far" [ngClass]="iconClass"></i>
      <rask-text-expander
        [text]="item.message"
        [rows]="maxNumOfRows"
      ></rask-text-expander>
    </div>
    @if (hasAnchor) {
      <div class="anchor-wrapper">
        <span [ngClass]="anchorClass" (click)="anchorClicked()">
          <i class="far fa-arrow-right"></i>
          {{ anchorText }}
        </span>
      </div>
    }
  </div>
}
